const whereBuyInitialState = {
  cities:             [],
  filter:             [],
  initialStateLoaded: false,
  items:              [],
  loading:            false,
  regionData:         {
    title:           null,
    description:     null,
    metaTitle:       null,
    metaKeywords:    null,
    metaDescription: null,
    lat:             null,
    lng:             null,
    mapZoom:         null,
  },
  regions:            [],
  types:              [],
  typeTradeStore:     null,
};

export default whereBuyInitialState;